import { Block } from 'baseui/block';
import { NavigationButton } from '../../components/NavigationButton/NavigationButton'
import { CurrentUserAvatar } from '../../components/User/CurrentUserAvatar'
// api
import { IoHomeOutline, IoGridOutline, IoQrCodeOutline } from 'react-icons/io5'
import { AlarmNavigationButton } from "../AlarmNavigationButton/AlarmNavigationButton";
import { DevicePlatform, useFlutterAppInterface } from '../../hooks/useFlutterAppInterface';


export function Footer(props: any) {

  const { platform } = useFlutterAppInterface();

  const margin = platform === DevicePlatform.iOS ? '5px 5px 0px 5px' : '5px';
  return (
    <Block margin={margin}   display='flex' flexDirection='row'  justifyContent='space-around' alignItems='center'  >
      <NavigationButton href='/objects' title='Objects'>
        <IoHomeOutline></IoHomeOutline>
      </NavigationButton>
      <NavigationButton href='/dashboards' title='Dashboards' >
        <IoGridOutline></IoGridOutline>
      </NavigationButton>

      <AlarmNavigationButton></AlarmNavigationButton>
      <NavigationButton href='/QRCode' title='QRCode-Scanner' >
          <IoQrCodeOutline ></IoQrCodeOutline>
        </NavigationButton>
      <CurrentUserAvatar></CurrentUserAvatar>
    </Block>
  )
}
